import React from "react";
import {useTranslation} from "react-i18next";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import {Card} from "antd";
import {capitalize} from "lodash";
import AlertParametersContent from "./AlertParametersContent";

export default function AlertParametersCard() {

  const {t} = useTranslation()
  const {xs} = useBreakpoint()

  return <Card
    title={capitalize(t('assets.alertParameters'))}
    bodyStyle={{
      ...xs && {padding: 0}
    }}
  >
    <AlertParametersContent/>
  </Card>
}